<div class="monitors row" style="padding-top: 10px;">

  <div class="col-2" style="padding-left: 5px; padding-right: 5px;">
    <div class="monitor-panel">
      @for (section of sections; track section) {
      <div>
        <p class="monitor-header">{{section.header}}</p>
        <ul>
          @for (category of section.categories; track category) {
          <li class="monitor-category" [ngClass]="{'monitor-category-selected': selectedCategory === category.value}"
            (click)="onCategoryClicked(category.value)">{{category.title}}</li>
          }
        </ul>
      </div>
      }
    </div>
  </div>

  <div class="col-10" style="padding-left: 5px; padding-right: 5px;">
    @if (selectedSection === 'monitors') {
    <div>
      <p-table #monitorsTable class="monitors-table" [value]="monitorsEntries" dataKey="monitorPolicyGuid"
        [resizableColumns]="true" rowHover="true" [scrollable]="true" [scrollHeight]="scrollHeight" [customSort]="true"
        (sortFunction)="doCustomSort_Monitors($event)">
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn pSortableColumn="name">
              Name
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="agent">
              Agent
              <p-sortIcon field="agent"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="enabled">
              Enabled
              <p-sortIcon field="enabled"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="state">
              State
              <p-sortIcon field="state"></p-sortIcon>
            </th>
            <th [ngClass]="{'uv-table-button-column-2': !enableEditing, 'uv-table-button-column-5': enableEditing }">
              <!-- Action buttons -->
            </th>
          </tr>
          <tr class="uv-table-filter">
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitorsTable.filter($event.target.value, 'name', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitorsTable.filter($event.target.value, 'agent', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitorsTable.filter($event.target.value, 'enabled', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitorsTable.filter($event.target.value, 'state', 'contains')">
            </th>
            <th [ngClass]="{'uv-table-button-column-2': !enableEditing, 'uv-table-button-column-5': enableEditing }">
              <!-- Action buttons -->
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr [pSelectableRow]="rowData">
            <td (click)="viewMonitorState(rowData)">
              <span class="uv-table-value">{{rowData['name']}}</span>
            </td>
            <td (click)="viewMonitorState(rowData)">
              <span class="uv-table-value">{{rowData['agent']}}</span>
            </td>
            <td class="uv-table-enable-checkbox">
              <p-checkbox binary="true" [ngModel]="rowData.enabled"
                (click)="togglePolicyEnableState(rowData)"></p-checkbox>
            </td>
            <td [className]="rowData['style']" (click)="viewMonitorState(rowData)">
              <span class="uv-table-value">{{rowData['state']}}</span>
            </td>
            <td [ngClass]="{'uv-table-button-column-2': !enableEditing, 'uv-table-button-column-5': enableEditing }">
              @if (enableEditing) {
              <button type="button" class="btn btn-primary uv-first-table-button" (click)="editMonitorPolicy(rowData)"
                title="Edit this policy">
                <i class="fa fa-edit"></i>
              </button>
              }
              @if (enableHistory) {
              <button type="button" class="btn btn-primary"
                [ngClass]="{'uv-first-table-button': !enableEditing, 'uv-table-button': enableEditing}"
                (click)="viewMonitorHistory(rowData)" title="View historical data for this policy">
                <i class="fa fa-history"></i>
              </button>
              }
              <button type="button" class="btn btn-primary uv-table-button" (click)="runPolicyAsap(rowData)"
                title="Run this policy ASAP">
                <i class="fa fa-caret-square-o-right"></i>
              </button>
              @if (enableEditing) {
              <button type="button" class="btn btn-danger uv-table-button" (click)="confirmDeleteMonitorPolicy(rowData)"
                title="Delete this policy">
                <i class="pi pi-trash"></i>
              </button>
              }
              @if (enableHistory && enableEditing) {
              <button type="button" class="btn btn-danger uv-table-button" (click)="clearPolicyHistoryAsap(rowData)"
                title="Clear historical data for this policy ASAP">
                <i class="fa fa-eraser"></i>
              </button>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
      <hr />
      <div style="margin-top: 10px;">
        @if (enableEditing) {
        <button type="button" (click)="addMonitorPolicy()" pButton icon="fa fa-plus-square-o"
          label="Add Policy"></button>
        }
        <button type="button" (click)="refreshMonitorPolicies()" pButton icon="fa fa-refresh" label="Refresh"></button>
      </div>
      <ping-monitor [(visible)]="pingEditorVisible" [target]="selectedPingPolicy" (onSave)="onSave()"
        (onCancel)="onCancel()"></ping-monitor>
      <ping-state [(visible)]="pingStateVisible" [target]="selectedPingPolicy"></ping-state>
      <snmpif-monitor [(visible)]="snmpIfEditorVisible" [target]="selectedSnmpIfPolicy" (onSave)="onSave()"
        (onCancel)="onCancel()"></snmpif-monitor>
      <snmpif-state [(visible)]="snmpIfStateVisible" [target]="selectedSnmpIfPolicy"></snmpif-state>
      <config-monitor [(visible)]="configEditorVisible" [target]="selectedConfigPolicy" (onSave)="onSave()"
        (onCancel)="onCancel()"></config-monitor>
      <config-state [(visible)]="configStateVisible" [target]="selectedConfigPolicy"></config-state>
      <custom-snmp-monitor [(visible)]="customSnmpEditorVisible" [target]="selectedCustomSnmpPolicy" (onSave)="onSave()"
        (onCancel)="onCancel()"></custom-snmp-monitor>
      <custom-snmp-state [(visible)]="customSnmpStateVisible" [target]="selectedCustomSnmpPolicy"></custom-snmp-state>
      <prtg-monitor [(visible)]="prtgEditorVisible" [target]="selectedPrtgPolicy" (onSave)="onSave()"
        (onCancel)="onCancel()"></prtg-monitor>
    </div>
    }

    @if (selectedSection === 'monitored-devices') {
    <div>
      <p-table #monitoredDevicesTable class="monitors-table" [value]="monitoredDevicesEntries" dataKey="deviceGuid"
        [resizableColumns]="true" rowHover="true" [scrollable]="true" [scrollHeight]="scrollHeight" [customSort]="true"
        (sortFunction)="doCustomSort_MonitoredDevices($event)">
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn pSortableColumn="name">
              Name
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="ipAddress">
              IP Address
              <p-sortIcon field="ipAddress"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="macAddress">
              MAC Address
              <p-sortIcon field="macAddress"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="description">
              Description
              <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="vendor">
              Vendor
              <p-sortIcon field="vendor"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="state">
              State
              <p-sortIcon field="state"></p-sortIcon>
            </th>
            <th [ngClass]="{'uv-table-button-column-2': !enableEditing, 'uv-table-button-column-4': enableEditing }">
              <!-- Action buttons -->
            </th>
          </tr>
          <tr class="uv-table-filter">
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitoredDevicesTable.filter($event.target.value, 'name', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitoredDevicesTable.filter($event.target.value, 'ipAddress', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitoredDevicesTable.filter($event.target.value, 'macAddress', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitoredDevicesTable.filter($event.target.value, 'description', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitoredDevicesTable.filter($event.target.value, 'vendor', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="monitoredDevicesTable.filter($event.target.value, 'state', 'contains')">
            </th>
            <th [ngClass]="{'uv-table-button-column-2': !enableEditing, 'uv-table-button-column-4': enableEditing }">
              <!-- Action buttons -->
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr [pSelectableRow]="rowData">
            <td (click)="viewDeviceState(rowData)">
              <span class="uv-table-value">{{rowData['name']}}</span>
            </td>
            <td (click)="viewDeviceState(rowData)">
              <span class="uv-table-value">{{rowData['ipAddress']}}</span>
            </td>
            <td (click)="viewDeviceState(rowData)">
              <span class="uv-table-value">{{rowData['macAddress']}}</span>
            </td>
            <td (click)="viewDeviceState(rowData)">
              <span class="uv-table-value">{{rowData['description']}}</span>
            </td>
            <td (click)="viewDeviceState(rowData)">
              <span class="uv-table-value">{{rowData['vendor']}}</span>
            </td>
            <td [className]="rowData['style']" (click)="viewDeviceState(rowData)">
              <span class="uv-table-value">{{rowData['state']}}</span>
            </td>
            <td [ngClass]="{'uv-table-button-column-2': !enableEditing, 'uv-table-button-column-4': enableEditing }">
              <span class="uv-first-table-button" title="View device monitor history">
                <p-splitButton label="" icon="fa fa-history" [model]="deviceHistoryMenuItems(rowData)"
                  appendTo="body"></p-splitButton>
              </span>
              @if (enableEditing) {
              <button type="button" (click)="updateMonitoredDevice(rowData)" class="btn btn-primary uv-table-button"
                title="Update this device with the most recent discovery data">
                <i class="fa fa-refresh"></i>
              </button>
              }
              @if (enableEditing) {
              <button type="button" (click)="confirmDeleteMonitoredDevice(rowData)"
                class="btn btn-danger uv-table-button" title="Remove all monitors from this device">
                <i class="pi pi-trash"></i>
              </button>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
      <hr />
      <div style="margin-top: 10px;">
        <button type="button" (click)="refreshMonitoredDevices()" pButton icon="fa fa-refresh" label="Refresh"></button>
      </div>
      <device-state [(visible)]="monitoredDeviceStateVisible" [target]="selectedMonitoredDeviceEntry"></device-state>
    </div>
    }

    <ping-history-dialog [(visible)]="pingHistoryVisible" [monitorType]="selectedMonitorType"
      [monitorPolicyGuid]="selectedMonitorPolicyGuid" [deviceGuid]="selectedDeviceGuid"></ping-history-dialog>

    <snmpif-history-dialog [(visible)]="snmpIfHistoryVisible" [monitorType]="selectedMonitorType"
      [monitorPolicyGuid]="selectedMonitorPolicyGuid" [deviceGuid]="selectedDeviceGuid"></snmpif-history-dialog>

    <config-history-dialog [(visible)]="configHistoryVisible" [monitorType]="selectedMonitorType"
      [monitorPolicyGuid]="selectedMonitorPolicyGuid" [deviceGuid]="selectedDeviceGuid"></config-history-dialog>

    <custom-snmp-history-dialog [(visible)]="customSnmpHistoryVisible" [monitorType]="selectedMonitorType"
      [monitorPolicyGuid]="selectedMonitorPolicyGuid" [deviceGuid]="selectedDeviceGuid"></custom-snmp-history-dialog>

    <prtg-history-dialog [(visible)]="prtgHistoryVisible" [monitorType]="selectedMonitorType"
      [monitorPolicyGuid]="selectedMonitorPolicyGuid"></prtg-history-dialog>

  </div>

  <confirmation-dialog [message]="deleteMonitorPolicyConfirmMessage" [display]="displayDeleteMonitorPolicyConfirm"
    (onYes)="deleteMonitorPolicy()" (onNo)="cancelDeleteMonitorPolicy()">
  </confirmation-dialog>


  <confirmation-dialog [message]="deleteMonitoredDeviceConfirmMessage" [display]="displayDeleteMonitoredDeviceConfirm"
    (onYes)="deleteMonitoredDevice()" (onNo)="cancelDeleteMonitoredDevice()">
  </confirmation-dialog>

</div>